export default __webpack_public_path__ + "static/media/04.e02dbf3d.png";